import { useTranslations } from '@vocab/react';
import { Alert, Stack, Strong, ContentBlock, Text } from 'braid-design-system';
import React, { useEffect, useState, type ComponentType } from 'react';

import { BrandOwnerType } from 'src/App/generated/graphql-types';
import { getUserInfo } from 'src/modules/authHandler';

import translations from './.vocab';

export const useWithEmailVerify = () => {
  const [isVerified, setIsVerified] = useState(true);
  const [email, setEmail] = useState('');

  useEffect(() => {
    getUserInfo().then((userInfo: any) => {
      if (!userInfo.email_verified) {
        setIsVerified(false);
      }
      setEmail(userInfo.email);
    });
  }, []);

  return {
    isVerified,
    email,
    ownerType: isVerified ? BrandOwnerType.SEEKID : BrandOwnerType.ADVERTISERID,
  };
};

// eslint-disable-next-line
const withEmailVerify =
  <P extends Record<string, unknown>>(BaseComponent: ComponentType<P>) =>
  (props: any) => {
    const { isVerified, email } = useWithEmailVerify();

    const { t } = useTranslations(translations);

    if (isVerified) {
      return <BaseComponent {...props} />;
    }

    return (
      <ContentBlock data-testid="alert-content">
        <Alert id="confirm-email-alert" tone="caution">
          <Stack space="medium">
            <Text>
              <Strong>
                {t('Verify your account to create your first brand')}
              </Strong>
            </Text>
            <Text>
              {t(
                'Please confirm your email address by clicking on the link sent to',
              )}
              <Strong>{email}</Strong>
            </Text>
          </Stack>
        </Alert>
      </ContentBlock>
    );
  };

export default withEmailVerify;
